import { render, staticRenderFns } from "./MyTaskModal.vue?vue&type=template&id=6cd2b005"
import script from "./MyTaskModal.vue?vue&type=script&lang=js"
export * from "./MyTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports